export default {
  logs:{
    filter: "Filtrer",
    searchPlaceholder: "Rechercher par module, action ou commentaire...",
    table: {
      date: "Date",
      module: "Module",
      action: "Action",
      comment: "Commentaire",
      noResults: "Aucun log trouvé",
    },
    filterPopup: {
      title: "Filtrer les Logs",
      module: "Module",
      modulePlaceholder: "Nom du module",
      action: "Action",
      actionPlaceholder: "Type d'action",
      comment: "Commentaire",
      commentPlaceholder: "Contenu du commentaire",
      dateMin: "Date minimale",
      dateMax: "Date maximale",
      allProjects: "Tous",
      project: "projet"
    }
  }
};
